'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeCallParticipants');

var KayleeCallParticipants = {
    fromJson: fromJson,
    getCallParticipants: getCallParticipants,
};

function fromJson(data) {
    var reqProps = [ '$callId' ];
    return FirebaseArray.$fromJson(data, 'CallParticipants', reqProps, reqProps,
        function(data) { return getCallParticipants(data.$callId); }
    );
}

function getCallParticipants(callId) {
    var key = 'CallParticipants: ' + callId;
    var callParticipants = KayleeCache.get(key);

    if (callParticipants === null) {
        callParticipants = new CallParticipants(callId);
        KayleeCache.put(key, callParticipants);
    }

    return callParticipants;
}

function CallParticipants(callId) {
    this.$nodeType = 'callParticipants';
    this.$callId = callId;
    FirebaseArray.call(this, KayleeBase.app.database().ref('callParticipants/' + callId));
    KayleeUtil.bindPrototypeMethods(CallParticipants.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

CallParticipants.prototype = Object.create(FirebaseArray.prototype);
CallParticipants.prototype.constructor = CallParticipants;

CallParticipants.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this, [ '$callId' ], {});
};

CallParticipants.prototype.toString = function() {
    return '[CallParticipants (' + this.$callId + ')]';
};

CallParticipants.prototype.$clear = function() {
    return this.$ref.set(null);
};

// participant: new participant, updated participant, or null

CallParticipants.prototype.$set = function(participantId, participant) {
    var ref = this.$ref.child(participantId);

    return ref.set(participant)
    .then(function() {
        return Promise.resolve();
    }, function(err) {
        log.debug('ref = ' + ref.toString());
        log.debug('participant = ' + JSON.stringify(participant));
        log.error('set participant failed, error: ' + err);
        return Promise.reject(err);
    });
};

// note: participants is an object; the keys will be the new $id's of the items

CallParticipants.prototype.$setAll = function(participants) {
    var ref = this.$ref;

    return ref.set(participants)
    .then(function() {
        return Promise.resolve();
    }, function(err) {
        log.debug('ref = ' + ref.toString());
        log.debug('participants = ' + JSON.stringify(participants));
        log.error('set participants failed, error: ' + err);
        return Promise.reject(err);
    });
};

module.exports = KayleeCallParticipants;
